import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'osp-component-placeholder',
  standalone: true,
  imports: [],
  templateUrl: './component-placeholder.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ComponentPlaceholderComponent {

}
